module.exports = __webpack_public_path__ + "img/stock5.799ecd36.png";